import React from "react";
import './ProductimgSlide.css';
import Slider from "react-slick";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import  './ProductListSlider.css';
import axios from 'axios';
class ProductimgSlider extends React.Component {
    constructor() {
        super();
        this.state = {
            thumnailIMG :[],
            list : []

        }
    }; 
    componentDidMount(){
        const USR_TOKEN = localStorage.getItem("userToken")
        axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Website Item/'+this.props.thumnailName), {
            headers : {'Authorization' : USR_TOKEN, 
                'content-type': 'application/json'}
        })
        .then(response=>{
            this.setState({list:response.data.data.product_images})
            //console.log(response.data.data)  
        })
        .catch(response=>{
            // console.log(response+' api/method/ecom.api.latest_items')
        })
      }
      

  

    render() {
        var settings = {
            dots: false,
            infinite: true,
            autoplay: false,
            autoplaySpeed: 2000,
            slidesToShow: 5,
            slidesToScroll: 1,
            pauseOnHover: true,
            nextArrow: (
              <div>
                <div className="next-slick-arrow mob-d-none"> <ArrowForwardIosIcon/> </div>
              </div>
            ),
          prevArrow: (
              <div>
                 <div className="next-slick-arrow mob-d-none"> <ArrowBackIosNewIcon/> </div>
              </div>
            ), 
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    arrows: false,
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                    arrows: false,
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                  }
                }
              ]
        }
        if (this.state.list)
         return <>
         {this.state.list.length >5 ?
                <div className="custom-block-img mt-1 mb-1">
                    <Slider {...settings}>
                            {this.state.list.map((item,k)=>{
                                            return(
                            <div className="sub-single-block m-1" key={k}>
                                <img className="sub-single-img" src={process.env.REACT_APP_API_URL + item.image} alt="" width= "110px" onClick={()=>this.props.thumnailPass(item.image)}/>
                            </div>
                                )
                            })} 
                            </Slider> 
                </div>  :
                <div className="custom-block-img mt-1 mb-1">  
                        {this.state.list.map((item,k)=>{
                                        return(
                        <div className="sub-single-block m-1" key={k}>
                            <img className="sub-single-img" src={process.env.REACT_APP_API_URL + item.image} alt="" width= "110px" onClick={()=>this.props.thumnailPass(item.image)}/>
                        </div>
                        )
                        })} 
                    
                    
                    </div>
                }
                </>
                
         else 
         return ""   
    }
}
export default ProductimgSlider;
